var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('v-container',[_c('v-card',[_c('fma-listing',{attrs:{"listing":_vm.currentListing}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }